import { Box, Button, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';
import { postMarkAsPaid } from '../../redux/features/refundSlice';

const UpdatePaymentStatus = ({ nonEnrollment, rowData, setOpen, dispatchParams, apiAfterSuccess }) => {
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();

  const { submitionLoading } = useSelector((state) => state.refund);

  const onSubmit = () => {
    dispatch(
      postMarkAsPaid({
        non: nonEnrollment,
        data: nonEnrollment
          ? { holdamount_refund_id: rowData?.holdamount_refund_id }
          : { expense_id: rowData?.expense_id },
      })
    ).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(apiAfterSuccess(dispatchParams));
        },
      });
    });
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: 'column',
          minWidth: 250,
        }}
      >
        <Typography variant="subtitle1">Are you sure to mark as paid?</Typography>
        <Stack
          direction={'row'}
          spacing={1}
          sx={{
            alignSelf: 'flex-end',
          }}
        >
          <Button size="small" variant="outlined" color="info" onClick={() => handleCancel()}>
            Cancel
          </Button>
          <Button disabled={submitionLoading} variant="contained" color="info" size="small" onClick={() => onSubmit()}>
            {submitionLoading ? 'Please wait...' : 'Confirm'}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default UpdatePaymentStatus;
